var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgPlayerP1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 145,
    viewBox: "0 0 100 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 25.5L46 22.5L53 21L60.5 23L65.5 26L68.5 30L69.5 33L70 36.5L75 37.5L80 40V41.5L73.5 40.5L70 41.5L69 43V51L68.5 56.5L67.5 61L66.5 63L68.5 64.5L85 74L87.5 77L91.5 91L92.5 101L93.5 109L92.5 126L92 132L91.5 144.5H2L6.5 127L10 122.5L12.5 122H14.5L19.5 122.5L26 124.5L28 105L25.5 97L21 96L6.5 102H3.5L0 105.5V72L9.5 61.5L12 59L7.5 56L2.5 52.5V49.5L3.5 46.5L5 45.5L6.5 46L8.5 44.5L12 43L14 42.5L14.5 41V39.5L16.5 36.5L20.5 35.5L29 37.5L35.5 41.5L36.5 39L37 33.5L38 29.5L41 25.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPlayerP1);
export default __webpack_public_path__ + "static/media/bg_player_p1.e2f0e0ee3c273c2f38387f4532293a8d.svg";
export { ForwardRef as ReactComponent };